import { render, staticRenderFns } from "./AustralianResidencyStatus.vue?vue&type=template&id=67719ea5&"
import script from "./AustralianResidencyStatus.vue?vue&type=script&lang=js&"
export * from "./AustralianResidencyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports